import { useFormikContext } from 'formik';
import { Input } from 'shared-components';
import { Label } from 'shared-components';
import { FormGroup } from 'shared-components';
import styles from './edit-field-form.module.css';
import { IFormField, IProduct } from '@topshots/core-models';
import { Select } from 'shared-components';
import { Checkbox } from 'shared-components';
import { Button } from 'shared-components';
import { FormLayout } from 'shared-components';
import { XMarkIcon } from '@heroicons/react/24/outline';

export const EditFieldForm = ({
  onDone,
  field,
  index,
}: {
  onDone: () => void;
  field: IFormField;
  index: number;
}) => {
  const { getFieldProps, values, setFieldValue } =
    useFormikContext<Partial<IProduct>>();

  return (
    <FormLayout className={styles.fieldInputs}>
      <FormGroup>
        <Label htmlFor="id">Field Name</Label>
        <Input {...getFieldProps(`formSchema[${index}].id`)} id="id" />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="fieldLabel">Field Label</Label>
        <Input
          {...getFieldProps(`formSchema[${index}].label`)}
          id="fieldLabel"
        />
      </FormGroup>
      <FormGroup>
        <Label htmlFor="fieldType">Type</Label>
        <Select {...getFieldProps(`formSchema[${index}].type`)} id="fieldType">
          <option value="text">Text</option>
          <option value="number">Number</option>
          <option value="select">Select</option>
          <option value="checkbox">Checkbox</option>
          <option value="textarea">Text Area</option>
        </Select>
      </FormGroup>
      <FormGroup>
        <Checkbox
          label="Required"
          type="checkbox"
          id="fieldRequired"
          {...getFieldProps(`formSchema[${index}].required`)}
        />
      </FormGroup>
      {field.type === 'select' && (
        <div className={styles.selectOptions}>
          <label>Options:</label>
          {values?.formSchema?.[index].options?.map((option, optionIndex) => (
            <div key={optionIndex} className={styles.optionItem}>
              <Input
                value={option}
                onChange={(e) => {
                  setFieldValue(
                    `formSchema[${index}].options`,
                    values?.formSchema?.[index].options?.map((opt, i) =>
                      i === optionIndex ? e.target.value : opt
                    )
                  );
                }}
              />
              <XMarkIcon
                className={styles.removeOption}
                onClick={() => {
                  setFieldValue(
                    `formSchema[${index}].options`,
                    values?.formSchema?.[index].options?.filter(
                      (_, i) => i !== optionIndex
                    )
                  );
                }}
              />
            </div>
          ))}
          <Button
            onClick={() => {
              setFieldValue(`formSchema[${index}].options`, [
                ...(values?.formSchema?.[index].options || []),
                '',
              ]);
            }}
          >
            Add Option
          </Button>
        </div>
      )}
      <FormGroup>
        <Button
          onClick={() => {
            onDone();
          }}
        >
          Done
        </Button>
      </FormGroup>
    </FormLayout>
  );
};
